import type { Signal } from "@suse-o11y/signal";
import { useRequiredContext } from "@suse-o11y/use-required-context";
import { createContext } from "react";

const ToggleListRootContext = createContext<null | Signal<string>>(null);

export const ToggleListRootContextProvider = ToggleListRootContext.Provider;

export const useToggleListNamespace = (): Signal<string> =>
	useRequiredContext(ToggleListRootContext, {
		providerName: "ToggleList.Root",
	});
